import { Link } from "react-router-dom";
import { Instagram, ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../../context/LangContext";
import { CATEGORIES } from "../../lib/i18n";
import { INSTAGRAM_URL } from "../../lib/api";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#241A3A] text-white/70 border-t border-[#F2C230]/30" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-5 max-w-sm">
          <Logo testid="footer-logo-link" />
          <p className="text-sm leading-relaxed">{t("footer_text")}</p>
          <p className="font-display italic text-[#C9B6F2] text-xl">{t("tagline")}</p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 text-sm border border-[#F2C230]/40 rounded-full px-4 py-2 hover:bg-[#F2C230] hover:text-[#120E1F] transition-colors">
            <Instagram className="h-4 w-4" /> @pn28cards
          </a>
        </div>
        <div>
          <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-4">{t("categories")}</h4>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.map((c) => <li key={c}><Link to={`/shop?category=${c}`} className="hover:text-[#C9B6F2] transition-colors">{t("cat")[c]}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-4">{t("legal")}</h4>
          <ul className="space-y-2 text-sm">
            {[["impressum", "impressum"], ["datenschutz", "privacy"], ["agb", "terms"], ["widerruf", "withdrawal"]].map(([p, k]) => (
              <li key={p}><Link to={`/legal/${p}`} data-testid={`footer-legal-${p}`} className="hover:text-[#C9B6F2] transition-colors">{t(k)}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center gap-3 justify-between text-xs">
          <span>© {new Date().getFullYear()} Jolgen Cards · {t("slogan")}</span>
          <span className="flex flex-wrap items-center justify-center gap-2"><ShieldCheck className="h-4 w-4 text-[#F2C230]" /> Stripe · Visa · Mastercard · Apple Pay · Klarna · DHL</span>
        </div>
      </div>
    </footer>
  );
};
